import { supabase } from "@/integrations/supabase/client";
import { logger } from "@/lib/logger";
import type {
  AppEventInput,
  AppEventActorType,
  AppEventSeverity,
} from "@shared/app-events/logAppEventCore";

export type { AppEventInput, AppEventActorType, AppEventSeverity };

export async function logAppEvent(input: AppEventInput): Promise<void> {
  try {
    // Route through observability Edge Function with query parameter action
    const { error } = await supabase.functions.invoke("observability?action=log_event", {
      body: input,
    });

    if (error) {
      // If function invoke fails (e.g. network), we just log to console
      console.warn("[logAppEvent] Edge Function failed", error);
    }
  } catch (error) {
    // Silent fail to not disrupt user experience
    console.warn("[logAppEvent] unexpected error", error);
  }
}
